module.exports = __webpack_public_path__ + "img/id.b9a8a6a2.png";